import React from 'react';
import Dropdown from 'src/components/atoms/Dropdown';
import {
  useAction,
  useFilterSettingsStore,
  useLabels,
} from 'src/StoreDataProvider';
import { ProjectSizeAndSortingProps } from './projectSizeAndSorting.types';

const ProjectSizeAndSorting: (
  props: ProjectSizeAndSortingProps
) => JSX.Element = () => {
  const { size, sort } = useFilterSettingsStore();
  const { setSize, setSorting } = useAction();
  const labels = useLabels();
  return (
    <section id="dropdownsPagination" className="dropdowns-page-container">
      <div className="dropdowns-page-container__entry-count-wrapper">
        <Dropdown
          id="DropDown_ShowPerPage"
          items={[
            { key: '10', value: '10' },
            { key: '25', value: '25' },
            { key: '50', value: '50' },
            { key: '100', value: '100' },
          ]}
          label={labels.resultsPerPage}
          onChange={selected => {
            setSize(parseInt(selected[0]));
          }}
          selected={[`${size}`]}
          multiple={false}
        />
      </div>
      <div className="dropdowns-page-container__sort-wrapper">
        <Dropdown
          id="DropDown_Sort"
          items={[
            { key: 'overallRating,DESC', value: `${labels.ratingDesc}` },
            { key: 'overallRating,ASC', value: `${labels.ratingAsc}` },
            { key: 'evaluationYear,DESC', value: `${labels.newestAsc}` },
            { key: 'evaluationYear,ASC', value: `${labels.oldestAsc}` },
          ]}
          label={labels.sortBy}
          onChange={selected => {
            setSorting(selected[0]);
          }}
          selected={[sort]}
        />
      </div>
    </section>
  );
};

export default ProjectSizeAndSorting;
